import React from "react";
import Sidebar from "react-sidebar";
import { renderRoutes } from "react-router-config";
import { Link, Route } from "react-router-dom";

import copy from "../../data/copy.js";

// Redux actions
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../actions";

import CabinetCover from "./CabinetCover";
import CabinetProject from "./CabinetProject";
import CabinetMethod from "./CabinetMethod";
import CabinetResources from "./CabinetResources";
import CabinetHistory from "./CabinetHistory";
import CabinetLogin from "./CabinetLogin";
import LanguageSelector from "./LanguageSelector";

class Cabinet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  toggleSidebar() {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen
    });
  }

  onSelectLanguage(languageId) {
    this.props.actions.selectLanguage(languageId);
  }

  renderLanguageSelector() {
    return (
      <LanguageSelector
        languageId={this.props.languageId}
        onSelectLanguage={languageId => {
          this.onSelectLanguage(languageId);
        }}
      />
    );
  }

  render() {
    const { languageId, isMobile } = this.props;
    const sidebarContent = (
      <div className="cabinet-file-tab-list">
        <div className="cabinet-file-tab">
          <Link to="/about">{copy[languageId].cabinet.terms.about}</Link>
        </div>
        <div className="cabinet-file-tab">
          <Link to="/history">{copy[languageId].cabinet.terms.history}</Link>
        </div>
        <div className="cabinet-file-tab">
          <Link to="/methodology">
            {copy[languageId].cabinet.terms.methodology}
          </Link>
        </div>
        <div className="cabinet-file-tab">
          <Link to="/resources">
            {copy[languageId].cabinet.terms.resources}
          </Link>
        </div>
        <div className="cabinet-file-tab">
          <Link to="/login">Log In</Link>
        </div>
        {this.renderLanguageSelector()}
      </div>
    );
    return (
      <div
        id="cabinet-content"
        className={`cabinet-wrapper cabinet-wrapper-cover cabinet-wrapper-files`}
      >
        <Sidebar
          sidebar={sidebarContent}
          open={this.state.sidebarOpen}
          onSetOpen={this.onSetSidebarOpen}
          styles={{
            sidebar: { backgroundColor: "rgb(164, 136, 98)", minWidth: "300px" }
          }}
        >
          <div id="scroll-case">
            {renderRoutes(this.props.route.routes, {
              sidebarOpen: this.state.sidebarOpen,
              toggleSidebar: this.toggleSidebar,
              languageId,
              onSelectLanguage: languageId => {
                this.onSelectLanguage(languageId);
              },
              isMobile
            })}
          </div>
        </Sidebar>
      </div>
    );
  }
}

Cabinet.defaultProps = {
  languageId: "en",
  isMobile: false,
  isWebGL: true
};

function mapStateToProps(state) {
  return {
    languageId: state.languageId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}
// connect(---) will return an object that will become props in App
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cabinet);



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/Cabinet.jsx